import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lds-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.css'],
    standalone: false
})
export class ProgressSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
